export default __webpack_public_path__ + "static/media/0x1E991eA872061103560700683991A6cF88BA0028.5a276b87.svg";